(function() {
  // Get the current URL's query string
  const params = new URLSearchParams(window.location.search)

  // Do nothing if the variable "cart" does not exist in the query string
  if (!params.has("cart")) {
    return
  }

  // Clear the cart object in the user's browser programatically with Shopify's cart API
  fetch("/cart/clear.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    }
  })
  .then(response => response.json())
  .then(data => {
    // console.log("Success: The cart has ben cleared.")
    // console.log(data)
    window.location.href = window.location.pathname
  })
  .catch(error => {
    console.error("Error: The cart could not be cleared.")
    // console.error(error)
  })
})()